import React, { useEffect, useRef } from 'react';
import './Filters.css';
import { MEDIA_URL } from "../../utils/constants";

function FilterItem({ name, isSelected, onClick, src, type }) {
  if (type === "filter"){
    return (
      <div
      className={`filter-item ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      >
      <img src={src} alt="" className="filter-img" />
      <p>{name.toUpperCase()}</p>
      </div>
    );
  }
  if (type === "brand") {
    return (
      <div
      className={`brand-filter-item ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      >
      <p>{name.toUpperCase()}</p>
      </div>
    );
  }
}

function Filters({ filterList, selectedFilters, toggleFilter, type }) {
  const rowRef = useRef(null);

  useEffect(() => {
    const handleScroll = (event) => {
      if (rowRef.current) {
        rowRef.current.scrollLeft += event.deltaY * 1.5; // Ajusta el multiplicador según sea necesario
        event.preventDefault();
      }
    };

    const rowElement = rowRef.current;
    if (rowElement) {
      rowElement.addEventListener('wheel', handleScroll, { passive: false });
    }

    return () => {
      if (rowElement) {
        rowElement.removeEventListener('wheel', handleScroll);
      }
    };
  }, []);

  return (
    <div className="filter-container">
      <ul className="filter-row">
        {filterList.map((item) => (
          <li key={item.id} className="filter-item" ref={rowRef}>
            <FilterItem
              name={item.name}
              isSelected={selectedFilters.includes(item.id, type)}
              onClick={() => toggleFilter(item.id)}
              src={MEDIA_URL + item.image}
              type={type}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Filters;
